import React, { memo } from 'react';
import styles from './evidenceSummary.module.css';

const TONE_CLASS = {
    success: styles.indicatorSuccess,
    warning: styles.indicatorWarning,
    neutral: styles.indicatorNeutral,
};

function SourceDiversityBadge({ diversity }) {
    if (!diversity?.label) return null;
    const tone =
        diversity.level === 'single' || diversity.level === 'limited'
            ? 'warning'
            : diversity.level === 'excellent'
              ? 'success'
              : 'neutral';
    return (
        <span className={`${styles.indicator} ${TONE_CLASS[tone] || TONE_CLASS.neutral}`}>
            {diversity.label}
        </span>
    );
}

export default memo(SourceDiversityBadge);
